import React, {Component} from 'react'
import RozkladService from "./RozkladService";

export default class PokazSzczegolyRozklad extends Component {

    constructor(props) {
        super(props);

        this.state = {
            przystanki: []
        }
    }

    componentDidMount() {
        RozkladService.getPrzystanki(this.props.item.idKu)
            .then(function (response) {
                this.setState({przystanki: response.data})
            }.bind(this)).catch(err => {
        });
    }

    render() {
        return <div>
            <hr/>
            <table id="tablePreview" className="table table-striped table-hover table-sm table-borderless"
                   style={{color: '#696969'}}>
                <thead>
                <tr>
                    <th width="10%">#</th>
                    <th width="15%">Przyjazd</th>
                    <th width="30%">Miejscowość</th>
                    <th width="45%">Przystanek</th>
                </tr>
                </thead>

                <tbody>
                {this.state.przystanki.map((item, index) => {
                    return <tr>
                        <td>
                            {index + 1}
                        </td>
                        <td>
                            {item.godzPr}
                        </td>
                        <td>
                            {item.nazwaMi}
                        </td>
                        <td>
                            {item.nazwaPr}
                        </td>
                    </tr>
                })}
                </tbody>
            </table>
        </div>
    }
}



// WEBPACK FOOTER //
// ./src/components/rozklad/PokazSzczegolyRozklad.js